import { FONT_FAMILY, typography } from 'styles/typography'
const themeStyles = colors => {
  const styles = {
    container: {
      fontFamily: FONT_FAMILY,
      marginBottom: 25,
      position: 'relative'
    },
    header: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 25
    },
    downLoadButton: {
      color: colors.white,
      backgroundColor: colors.primary,
      textTransform: 'uppercase',
      borderRadius: 25
    },
    printerIcon: {
      transform: 'scaleX(-1)'
    },
    printPage: {
      userSelect: 'none',
      overflowY: 'scroll',
      maxHeight: '70vh',
      marginTop: 45
    },
    printContainer: {
      backgroundColor: '#fff',
      margin: 0,
      padding: '15px 45px'
    },
    printPageCancelButton: {
      borderRadius: 25,
      minWidth: 90,
      backgroundColor: colors.white,
      color: colors.primary,
      border: `1px solid ${colors.primary}`,
      textTransform: 'uppercase',
      marginRight: 15
    },
    printPageCancelPrintButton: {
      borderRadius: 25,
      minWidth: 90,
      color: colors.white,
      backgroundColor: colors.primary,
      textTransform: 'uppercase'
    },
    printPageLogo: {
      transform: 'scale(1.5)',
      pointerEvents: 'none',
      margin: '55px 0px 35px 30px'
    },
    contentArea: {
      position: 'relative',
      minHeight: 450
    },
    noDataContainer: {
      container: {
        height: '198px'
      }
    },
    title: {
      fontSize: 20,
      marginBottom: 15,
      flexDirection: 'column',
      justifyContent: 'flex-end',
      color: colors.approxBlack,
      ...typography.fontBold
    },
    headerText: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontFamily: 'Arial',
      fontSize: 20,
      textAlign: 'left',
      marginBottom: 25,
      color: colors.black
    },
    headerTitle: {
      fontFamily: 'Arial',
      fontSize: 20,
      marginBottom: 25,
      fontWeight: 700,
      textAlign: 'center',
      color: colors.black
    },
    subHeaderText: {
      fontFamily: 'Arial',
      fontSize: 20,
      textAlign: 'left',
      color: colors.gray
    }
  }
  return styles
}

export default themeStyles

